import { render, staticRenderFns } from "./RealTimeView.vue?vue&type=template&id=56e04456&scoped=true"
import script from "./RealTimeView.vue?vue&type=script&lang=js"
export * from "./RealTimeView.vue?vue&type=script&lang=js"
import style0 from "./RealTimeView.vue?vue&type=style&index=0&id=56e04456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e04456",
  null
  
)

export default component.exports